import { ProductBuilderAction } from '.'
import { Product, ProductParameter } from '../../product/model'
import { takeLatest, put, call } from 'redux-saga/effects'
import { api } from '../../../core'
import { productAddToCart, productToAddToCartRequestDto, productMediaCreateItem } from '../../product/api'

export function* productBuilderAddToCart(action: { type: ProductBuilderAction, params: { product: Product, productParameters: ProductParameter[] } }) {
    yield put({ type: 'PRODUCT_BUILDER_LOADING_BEGIN' })
    const designValue = action.params.product.configuration['design']
    if (designValue && designValue.length && designValue[0].key === 'own' && (<any>designValue[0]).files && Array.isArray((<any>designValue[0]).files)) {
        const files: File[] = (<any>designValue[0]).files
        for (let i = 0; i < files.length; i++) {
            const file = files[i]
            const formData = new FormData()
            formData.append('file', file)
            // todo: add file name in a defined format
            // formData.append( prop?, filename );
            const nonce = window.wpSettings.nonce
            // todo: collect all the results and pass them to productToAddToCartRequestDto..
            const result = yield call(api, productMediaCreateItem(formData, nonce))
            // Is it okay to replace the parameters like this?
            designValue[0].filesUploaded.splice(i, 1, result.source_url)
        }
    }
    const addToCartRequest = productToAddToCartRequestDto(action.params.product, action.params.productParameters)
    const addToCartFormData = new FormData()
    addToCartFormData.append('_ajax_nonce', window.wpSettings.nonce)
    addToCartFormData.append('action', window.wpSettings.action)
    addToCartFormData.append('data', JSON.stringify(addToCartRequest))
    yield call(api, productAddToCart(addToCartFormData))
    yield put({ type: 'PRODUCT_BUILDER_LOADING_END' })
    window.location.replace('/cart/')
}

export function* productBuilderAddToCartWatch() {
    yield takeLatest('PRODUCT_BUILDER_ADD_TO_CART', productBuilderAddToCart)
}
